class FacetsCounterCalculator {
  static loadItemsWithCounters(facetCounterAttribute, renderOptions, container, onLoad, comparisonFn) {
    const { items, refine, widgetParams, searchForItems } = renderOptions
    const indexName = renderOptions.instantSearchInstance.indexName
    const index = renderOptions.instantSearchInstance.client.initIndex(indexName)
    const filters = renderOptions.instantSearchInstance.searchParameters.filters

    const facetFilters = this.buildFacetFilters(renderOptions)

    comparisonFn ||= this.defaultComparisonFn

    index.search("", {
      hitsPerPage: 10000,
      facetFilters: facetFilters,
      filters: filters
    }).then(({hits}) => {
      const updatedItems = this.buildUpdatedItems(hits, facetFilters, items, facetCounterAttribute, comparisonFn)
      // Call the callback function to load the items into the document
      onLoad(updatedItems, refine, widgetParams, container, searchForItems)
    })
  }

  static buildFacetFilters(renderOptions) {
    const { widgetParams } = renderOptions
    const facetFilters = []
    const disjunctiveFacetsRefinements = renderOptions.instantSearchInstance.helper.state.disjunctiveFacetsRefinements

    Object.keys(disjunctiveFacetsRefinements).forEach((key) => {
      // If the operator is OR then we don't filter by the widget's attribute
      if (widgetParams.operator === "and" || key !== widgetParams.attribute) {
        const valuesPerKey = disjunctiveFacetsRefinements[key].map((ref) => {
          return `${key}:${ref}`
        })

        facetFilters.push(valuesPerKey.length > 1 ? valuesPerKey : valuesPerKey[0])
      }
    })

    return facetFilters
  }

  static buildUpdatedItems(hits, facetFilters, items, facetCounterAttribute, comparisonFn) {
    // We iterate over the items and update the count
    const outdatedAccreditations = []

    const updatedItems = items.map((item) => {
      // We count how many times the value is found in the facetCounterAttribute in the hits
      const count = hits.filter((el) => {
        const value = el[facetCounterAttribute]
        if (el[facetCounterAttribute] !== null &&  el[facetCounterAttribute] !== undefined) {
          return comparisonFn(value, item.value, facetFilters)
        } else {
          outdatedAccreditations.push(el.objectID)
        }
      }).length

      if (count > 0) {
        return {
          ...item,
          count: count
        }
      }
    }).filter((item) => { return item }) // Discard null objects (count == 0)

    if (outdatedAccreditations.length > 0) {
      console.log('Outdated accreditations:')
      console.log([...new Set(outdatedAccreditations)])
    }

    return updatedItems
  }

  static defaultComparisonFn(hitValue, facetValue, facetFilters) {
    return Array.isArray(hitValue) ? hitValue.indexOf(facetValue) >= 0 : hitValue.toString() === facetValue.toString()
  }
}

export default FacetsCounterCalculator
